import React, { FC, useEffect, useState } from 'react';

import { GrowthBookProvider as SDKGrowthBookProvider } from '@growthbook/growthbook-react';

import FullscreenPreloader from '~/components/atoms/FullscreenPreloader';
import { USER_ID_KEY } from '~/constants';
import projectConfig from '~/projects/config';
import { growthBook } from '~/services/abTests/growthBook';
import localStorage from '~/services/storage/localStorage';
import { useAppSelector } from '~/store/hooks/useAppSelector';

import { funnelAttributesService } from '../funnelAttributes';

const growthBookInstance = growthBook.getInstance();

type Props = {
  children: React.ReactNode;
};

const GrowthBookProvider: FC<Props> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  const { id, created_at, is_stripe_user } = useAppSelector(
    (state) => state.profile,
  );

  useEffect(() => {
    const loadGrowthBook = async (): Promise<void> => {
      try {
        const userId = id || localStorage.getByKey(USER_ID_KEY);

        if (userId) {
          funnelAttributesService.captureFromUrl();

          await growthBook.init({
            //place for setting extra attributes
            id: userId,
            project: projectConfig.project,
            created_at,
            is_stripe_user,
            ...funnelAttributesService.getAll(),
          });
        }
      } finally {
        setIsLoading(false);
      }
    };

    loadGrowthBook();
  }, [id, is_stripe_user]);

  return (
    <SDKGrowthBookProvider growthbook={growthBookInstance}>
      {isLoading ? <FullscreenPreloader /> : <>{children}</>}
    </SDKGrowthBookProvider>
  );
};

export default GrowthBookProvider;
